import {Component} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-promo-banner',
  templateUrl: './promo-banner.component.html',
  styleUrl: './promo-banner.component.scss',
  imports: [RouterLink],
})
export class PromoBannerComponent {
  protected isPromoBannerEnabled: boolean = environment.isPromoBannerEnabled;

  constructor() {
  }
}
